import store from '../store/index';
import { removeCouponCode, showTweetResponse } from '../lib';

// Tweet popup form
let state = store.state.cartState ? store.state.cartState : {};
let popup = document.querySelector('.popup-wrapper');
let popupBox = document.querySelector('.popup-box');
let popupBtn = document.querySelector('#popupform');
let popupClose = document.querySelector('.close-btn');
let tweetForm1 = document.querySelector('#tweet-form1');
let tweetForm2 = document.querySelector('#tweet-form2');
let tweetBoxMessage1 = document.querySelector('.tweet-box-message1');
let tweetBoxMessage2 = document.querySelector('.tweet-box-message2');

popupBtn?.addEventListener('click', e => {
    e.preventDefault();
    if(state.coupon_hide != true){
        removeCouponCode();
        showPopup();
    }
});

popupClose?.addEventListener('click', e => {
    e.preventDefault();
    removePopup();
});

popupBox?.addEventListener('submit', () => {
    removePopup();
});

popup?.addEventListener('click', e => {
    let target = e.target;
    if (target.classList.contains('popup-wrapper')) {
        removePopup();
    } else return;
});

function showPopup() {
    tweetBoxMessage1.innerHTML = '';
    tweetBoxMessage2.innerHTML = '';
    popup.classList.add('active');
    popup.style.display = 'block';
    bodyScrollDisable();
}

function removePopup() {
    popup.classList.remove('active');
    popup.style.display = 'none';
    bodyScrollEnable();
}

function bodyScrollDisable() {
    document.querySelector('body').style.overflowY = 'hidden';
}

function bodyScrollEnable() {
    document.querySelector('body').style.overflowY = 'scroll';
}

// To count characters of input text
document.getElementById('inputFieldTweet')?.addEventListener('keyup', function (event) {
    countChars(this);
    document.getElementById('selectFieldTweet').value = '';
});
document.getElementById('selectFieldTweet')?.addEventListener('change', function (event) {
    countChars(this);
    document.getElementById('inputFieldTweet').value = '';
});

function countChars(obj) {
    var maxLength = 165;
    var strLength = obj.value.length;
    var charRemain = maxLength - strLength;
    document.getElementById('charCountTweet').innerHTML = charRemain;
    tweetBoxMessage1.innerHTML = '';
}

// Tweet Button
document.getElementById('postTweet')?.addEventListener('click', () => {
    var select = document.getElementById('selectFieldTweet').value;
    var body = document.getElementById('inputFieldTweet').value;
    if (body == '' && select == '') {
        showTweetResponse(false, tweetBoxMessage1, cartParams.trans.tweet_selection);
        return;
    }
    tweetBoxMessage1.innerHTML = '';

    var prefix = document.getElementById('tweetPrefix').value;
    var suffix = document.getElementById('tweetSuffix').value;

    if (body != '') {
        var text = encodeURIComponent(prefix) + ' ' + encodeURIComponent(body) + '%0A' + encodeURIComponent(suffix);
    } else {
        var text = encodeURIComponent(prefix) + ' ' + encodeURIComponent(select) + '%0A' + encodeURIComponent(suffix);
    }

    var tweetIntentUrl = 'https://twitter.com/intent/tweet' + '?text=' + text;
    window.open(tweetIntentUrl);

    // toggle validation form
    setTimeout(function () {
        tweetForm1.style.display = 'none';
        tweetForm2.style.display = 'block';
    }, 500);
});

// Unlock Button
document.getElementById('unlockTweet')?.addEventListener('click', async () => {
    let tweetUrl = document.getElementById('validateTweet').value;
    if (tweetUrl == '') {
        showTweetResponse(false, tweetBoxMessage2, cartParams.trans.tweet_url);
        return;
    }
    tweetBoxMessage2.innerHTML = '';

    let tweetIdWithQueryParam = tweetUrl.split('/').pop();
    let tweetId = tweetIdWithQueryParam.split('?')[0];
    let apiURL = encodeURIComponent('https://cdn.syndication.twimg.com/tweet-result?id='+tweetId);

    try {
        const res = await fetch('https://cdn.builder.io/api/v1/proxy-api?url='+apiURL);
        if(res.status == 200) {
            const result = await res.json();
            if(result.text.includes('I choose to #CancelHate')) {
                showTweetResponse(true);
                removePopup();
                return;
            }
        }
        showTweetResponse(false, tweetBoxMessage2, cartParams.trans.invalid_tweet);
	} catch (err) {
        console.log(err);
	}
});
